import axios from 'axios'
import authHeader from './auth-header'

let API_URL = process.env.VUE_APP_BASE_API_URL;

class UserService {
    // POST Method
    storeImage(formData) {
        return axios.post(API_URL + 'admin/images', formData, { headers: authHeader() })
    }

    storeContent(formData) {
        return axios.post(API_URL + 'admin/contents_management', formData, { headers: authHeader() })
    }

    storeAdmin(formData) {
        return axios.post(API_URL + "admin/admins_managements", formData, { headers: authHeader() })
    }

    storeAdminUpdate(id, formData) {
        return axios.post(API_URL + 'admin/admins_managements/' + id + '?_method=PUT', formData, { headers: authHeader() })
    }

    storeUpdatePass(id, formData) {
        return axios.post(API_URL + 'admin/members_management/reset_password/' + id, formData, { headers: authHeader() })
    }

    storeAdminUpdatePass(id, formData) {
        return axios.post(API_URL + 'admin/admins_management/reset_password/' + id, formData, { headers: authHeader() })
    }

    storeSection(formData) {
        return axios.post(API_URL + 'admin/leadership_section_management', formData, { headers: authHeader() })
    }

    storeAssignLeader(formData) {
        return axios.post(API_URL + 'admin/assign_leadership_section', formData, { headers: authHeader() })
    }

    storeUpdateSection(id, formData) {
        return axios.post(API_URL + 'admin/leadership_section_management/' + id + '?_method=PUT', formData, { headers: authHeader() })
    }

    storeUpdateStatus(formData) {
        return axios.post(API_URL + 'admin/members_management/update_status', formData, { headers: authHeader() })
    }

    storeUpdatePayStatus(id, formData) {
        return axios.post(API_URL + 'admin/member_subscription/' + id + '?_method=PUT', formData, { headers: authHeader() })
    }

    storeConfirmUpdate(id) {
        return axios.get(API_URL + 'admin/members_management/confirm_change/' + id + '?_method=PUT', { headers: authHeader() })
    }

    storeRejectUpdate(id, formData) {
        return axios.post(API_URL + 'admin/members_management/reject_change/' + id, formData, { headers: authHeader() })
    }

    storeUpdateContent(id, formData) {
        return axios.post(API_URL + 'admin/contents_management/' + id + '?_method=PUT', formData, { headers: authHeader() })
    }

    storeUpdatePage(id, formData) {
        return axios.post(API_URL + 'admin/pages_management/' + id + '?_method=PUT', formData, { headers: authHeader() })
    }

    storeUpdateProfile(formData) {
        return axios.post(API_URL + 'admin/aaac_profile_management', formData, { headers: authHeader() })
    }

    storeSubscription(formData) {
        return axios.post(API_URL + 'admin/subscriptions_management', formData, { headers: authHeader() })
    }

    storeUpdateSubscription(id, formData) {
        return axios.post(API_URL + 'admin/subscriptions_management/' + id + '?_method=PUT', formData, { headers: authHeader() })
    }

    storePayment(formData) {
        return axios.post(API_URL + 'admin/payments_management', formData, { headers: authHeader() })
    }

    storeUpdatePayment(id, formData) {
        return axios.post(API_URL + 'admin/payments_management/' + id + '?_method=PUT', formData, { headers: authHeader() })
    }

    storeBlockMessage(id) {
        return axios.post(API_URL + 'admin/contacts_form_management/block/' + id, null, { headers: authHeader() })
    }

    storeUpdateCategory(id, formData) {
        return axios.post(API_URL + 'admin/categories_management/' + id + '?_method=PUT', formData, { headers: authHeader() })
    }

    storeMember(formData) {
        return axios.post(API_URL + 'admin/members_management/create', formData, { headers: authHeader() })
    }

    storeImportMembers(formData) {
        return axios.post(API_URL + 'admin/members_management/import_multiple_member', formData, { headers: authHeader() })
    }

    storeReOrderSection(formData) {
        return axios.post(API_URL + 'admin/reorder_leadership_section', formData, { headers: authHeader() })
    }

    storeReOrderLeader(formData) {
        return axios.post(API_URL + 'admin/reorder_leader', formData, { headers: authHeader() })
    }

    storeUpdateSectionMember(id, formData) {
        return axios.post(API_URL + 'admin/update_leadership_section/' + id + '?_method=PUT', formData, { headers: authHeader() })
    }

    storeUpdateTitle(id, formData) {
        return axios.post(API_URL + 'admin/update_leadership_section/' + id + '?_method=PUT', formData, { headers: authHeader() })
    }

    storeCreateTitle(formData) {
        return axios.post(API_URL + 'admin/leadership_title_management', formData, { headers: authHeader() })
    }

    storeUpdateBoardTitle(id, formData) {
        return axios.post(API_URL + 'admin/leadership_title_management/' + id + '?_method=PUT', formData, { headers: authHeader() })
    }

    storeCreateMember(formData) {
        return axios.post(API_URL + 'admin/members_management/create', formData, { headers: authHeader() })
    }

    storeUpdateMember(id, formData) {
        return axios.post(API_URL + 'admin/members_management/update/' + id, formData, { headers: authHeader() })
    }

    storeUpdateMemberCategory(id, formData) {
        return axios.post(API_URL + 'admin/member_category_management/' + id + '?_method=PUT', formData, { headers: authHeader() })
    }

    storeUpdateMemberSector(id, formData) {
        return axios.post(API_URL + 'admin/member_sector_management/' + id + '?_method=PUT', formData, { headers: authHeader() })
    }

    storeUpdateMemberSubscription(id, formData) {
        return axios.post(API_URL + 'admin/members_management/update_member_subscription/' + id + '?_method=PUT', formData, { headers: authHeader() })
    }

    storeMarkInactiveMember(formData) {
        return axios.post(API_URL + 'admin/members_management/mark_member_inactive', formData, { headers: authHeader() })
    }

    sendRemindMessage(formData) {
        return axios.post(API_URL + 'admin/members_management/send_remaining_to_member', formData, { headers: authHeader() })
    }

    markMultipleMessageRead(formData) {
        return axios.post(API_URL + 'admin/contacts_form_management/mark_as_read_multiple', formData, { headers: authHeader() })
    }

    markMultipleNotificationRead(formData) {
        return axios.post(API_URL + 'admin/mark_as_read_notification_multiple', formData, { headers: authHeader() })
    }

    storeCreateMemberCategory(formData) {
        return axios.post(API_URL + 'admin/member_category_management', formData, { headers: authHeader() })
    }

    storeCreateMemberSector(formData) {
        return axios.post(API_URL + 'admin/member_sector_management', formData, { headers: authHeader() })
    }

    storePlayerId(formData) {
        return axios.post(API_URL + 'store_player_id', formData, { headers: authHeader() })
    }


    // GET Method
    getImage() {
        return axios.get(API_URL + 'admin/images', { headers: authHeader() })
    }

    getAdmins(params) {
        return axios.get(API_URL + 'admin/admins_managements', { params: params, headers: authHeader() })
    }

    getRoleList() {
        return axios.get(API_URL + 'admin/admins_management/roles_list', { headers: authHeader() })
    }

    getBordMember() {
        return axios.get(API_URL + 'admin/leadership_section_management', { headers: authHeader() })
    }

    getTitle() {
        return axios.get(API_URL + 'admin/leadership_title_management', { headers: authHeader() })
    }

    getMembers(params) {
        return axios.get(API_URL + 'admin/members_management', { params: params, headers: authHeader() })
    }

    getSubscriptionList() {
        return axios.get(API_URL + 'admin/subscriptions_management', { headers: authHeader() })
    }

    getMemberSubscriptionData(id) {
        return axios.get(API_URL + 'admin/member_subscription?user_id=' + id, { headers: authHeader() })
    }

    getMemberDetail(id) {
        return axios.get(API_URL + 'admin/members_management/show/' + id, { headers: authHeader() })
    }

    getContent(params) {
        return axios.get(API_URL + 'admin/contents_management', { params: params, headers: authHeader() })
    }

    getPage() {
        return axios.get(API_URL + 'admin/pages_management', { headers: authHeader() })
    }

    getPageDetail(id) {
        return axios.get(API_URL + 'admin/pages_management/' + id, { headers: authHeader() })
    }

    getPorfile() {
        return axios.get(API_URL + 'admin/aaac_profile_management', { headers: authHeader() })
    }

    getPaymentList() {
        return axios.get(API_URL + 'admin/payments_management', { headers: authHeader() })
    }

    getNotification(params) {
        return axios.get(API_URL + 'admin/notifications', { params: params, headers: authHeader() })
    }

    markNotificationRead(id) {
        return axios.get(API_URL + 'admin/mark_as_read_notification/' + id, { headers: authHeader() })
    }

    getInboxMessage(params) {
        return axios.get(API_URL + 'admin/contacts_form_management', { params: params, headers: authHeader() })
    }

    markMessageRead(id) {
        return axios.get(API_URL + 'admin/contacts_form_management/mark_as_read/' + id, { headers: authHeader() })
    }

    getCategory() {
        return axios.get(API_URL + 'admin/categories_management', { headers: authHeader() })
    }

    getDashboard() {
        return axios.get(API_URL + 'admin/dashboard/summary', { headers: authHeader() })
    }

    getMemberCategory() {
        return axios.get(API_URL + 'admin/member_category_management', { headers: authHeader() })
    }

    getMemberSector() {
        return axios.get(API_URL + 'admin/member_sector_management', { headers: authHeader() })
    }

    // DEL Method
    delAdmin(id) {
        return axios.delete(API_URL + 'admin/admins_managements/' + id, { headers: authHeader() })
    }

    delSection(id) {
        return axios.delete(API_URL + 'admin/leadership_section_management/' + id, { headers: authHeader() })
    }

    delDeActivate(id) {
        return axios.delete(API_URL + 'admin/members_management/deactivate_reactive/' + id, { headers: authHeader() })
    }

    delContent(id) {
        return axios.delete(API_URL + 'admin/contents_management/' + id, { headers: authHeader() })
    }

    delSubscription(id) {
        return axios.delete(API_URL + 'admin/subscriptions_management/' + id, { headers: authHeader() })
    }

    delPayment(id) {
        return axios.delete(API_URL + 'admin/payments_management/' + id, { headers: authHeader() })
    }

    delMessage(id) {
        return axios.delete(API_URL + 'admin/contacts_form_management/delete/' + id, { headers: authHeader() })
    }

    delMemberFromSection(id) {
        return axios.delete(API_URL + 'admin/remove_leadership_section/' + id, { headers: authHeader() })
    }

    delBoardTitle(id) {
        return axios.delete(API_URL + 'admin/leadership_title_management/' + id, { headers: authHeader() })
    }

    delUser(id) {
        return axios.delete(API_URL + 'admin/members_management/delete_member/' + id, { headers: authHeader() })
    }

    delMemberCategory(id) {
        return axios.delete(API_URL + 'admin/member_category_management/' + id, { headers: authHeader() })
    }

    delMemberSector(id) {
        return axios.delete(API_URL + 'admin/member_sector_management/' + id, { headers: authHeader() })
    }
}

export default new UserService();
